// extracted by mini-css-extract-plugin
export default {"NavItems":"NavItems_NavItems__xoy4K"};